import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useNewQuoteState } from 'shared/contexts';

export function OutOfScopeCustomer() {
  const { dialogOpen, toggleDialog } = useNewQuoteState();
  return (
    <Dialog open={dialogOpen} onClose={toggleDialog}>
      <DialogTitle>Unable to quote customer</DialogTitle>
      <DialogContent>
        <p>
          Please reach out to inside sales rep. This customer should not be priced through the quote tool due to one of
          the following:
        </p>
        <ol>
          <li>On Contract</li>
          <li>Out of Territory</li>
          <li>SPA</li>
        </ol>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            toggleDialog();
          }}
          variant='contained'
          color='primary'
        >
          ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
